import { css } from '@flipster/styled-system/css';

import Announcement from './sections/Announcement';
import Designed from './sections/Designed';
import Faq from './sections/Faq';
import SpotHero from './sections/Hero/SpotHero';

const SpotMainPage = () => {
  return (
    <main className={css({ pos: 'relative', overflowX: 'hidden', mb: { base: 56, tablet: 150 } })}>
      <SpotHero />
      <Announcement />
      <Designed />
      <Faq />
    </main>
  );
};

export default SpotMainPage;
